import { apiJson } from "./api";

const CODE_KEY = "marriage_couple_code";

export function getCoupleCode() {
  return (localStorage.getItem(CODE_KEY) || "").trim().toUpperCase();
}

export function setCoupleCode(code) {
  const next = (code || "").trim().toUpperCase();
  if (next) localStorage.setItem(CODE_KEY, next);
  else localStorage.removeItem(CODE_KEY);
  return next;
}

export function getUserId() {
  const raw = localStorage.getItem("user_id");
  const n = Number(raw);
  return Number.isInteger(n) && n > 0 ? n : null;
}

export async function fetchCoupleByUser(userId) {
  const { res, data } = await apiJson(`/api/marriage/couples/by-user/${userId}`);
  if (!res.ok) return null;
  if (data?.code) setCoupleCode(data.code);
  return data;
}

export async function ensureCoupleFromAccount(extra = {}) {
  const userId = getUserId();
  if (!userId) {
    throw new Error("请先登录网站账号，再用资料创建纪念码");
  }
  const { res, data } = await apiJson("/api/marriage/couples/ensure", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ user_id: userId, ...extra }),
  });
  if (!res.ok) throw new Error(data?.detail || "创建纪念码失败");
  if (data?.code) setCoupleCode(data.code);
  return data;
}
